//
// load the external payone_hosted.js if necessary else reject
//
async function loadPayone() {
  let elem = document.getElementById("creditcardcheck-data");
  let payoneModuleDefined = (typeof window.Payone !== typeof undefined);
  return await new Promise((resolve, reject) => {
    if (!elem) {
      // do not do anything if payone is not in view
      reject();
    } else if (!payoneModuleDefined) {
      // load script if payone_hosted.js was not loaded
      const uri = 'https://secure.pay1.de/client-api/js/v1/payone_hosted_min.js';
      const tag = document.createElement('script');
      tag.src = uri;
      tag.async = true;
      tag.addEventListener("load", resolve);
      document.head.appendChild(tag);
    } else {
      // resolve directly if script is already loaded
      resolve();
    }
    // return parsed JSON data from #creditcardcheck-data
  }).then(() => JSON.parse(elem.text));
}

document.addEventListener('DOMContentLoaded', () => {
  console.log("event DOMContentLoaded");
  loadPayone()
    .then((response) => {
      payone_cc_init(response)
    })
    .catch(() => {
      // do nothing if payone is not necessary);
    });
}, { once: true });

// embedded theme
// FIXME: it should not run everywhere
document.addEventListener('cart:render_complete', () => {
  console.log("event cart:render_complete");
  loadPayone()
    .then((response) => {
      payone_cc_init(response)
    })
    .catch(() => {
      // do nothing if payone is not necessary);
    });
}, { once: true });

function payone_cc_language() {
  if (document.documentElement.lang == 'de' ||
      document.documentElement.lang == 'de-DE') {
    return Payone.ClientApi.Language.de;
  } else {
    return Payone.ClientApi.Language.en;
  }
}

function payone_cc_incomplete_text() {
  if (document.documentElement.lang == 'de' ||
      document.documentElement.lang == 'de-DE')
    return "Die Angaben sind unvollständig.";
  else
    return "The provided data is incomplete.";
}

function payone_cc_init(request) {
  console.log("payone_cc_init")
  var payone_cc_config = {
    fields: {
      cardpan: {
	selector: "payone_cc_cardpan",
	style: "",
	type: "text"
      },
      cardcvc2: {
	selector: "payone_cc_cardcvc2",
	type: "text",
	style: "",
	size: "3",
	maxlength: "3",
	length: { "V": 3, "M": 3 } // enforce 3 digit CVC für VISA and Mastercard
      },
      cardexpiremonth: {
	selector: "payone_cc_expire_month",
	type: "text",
	size: "2",
	maxlength: "2",
	iframe: {
	  width: "40px"
	},
	style: ""
      },
      cardexpireyear: {
	selector: "payone_cc_expire_year",
	type: "text",
	maxlength: "4",
	iframe: {
	  width: "80px"
	},
	style: ""
      }
    },
    defaultStyle: {
      input: "font-size: 15px; color: #000; height: 38px; background-color: #f3f3f3; box-shadow: 2px 2px 1px #e1e1e1 inset; border: none; border-radius: 3px; padding: 7px 12px 7px 12px; margin: 0 0 8px 0; border: 1px solid #fff transparent; box-sizing: border-box; font-family: 'Notes-Regular', 'Helvetica', 'Arial', sans-serif;",
      select: "font-size: 1em; border: 1px solid #000;",
      iframe: {
	height: "40px",
	width: "200px"
      }
    },
    autoCardtypeDetection: {
      supportedCardtypes: ["V", "M"],
      callback: function(detectedCardtype) {
	// For the debug output container below.
	// document.getElementById('autodetectionResponsePre').innerHTML = detectedCardtype;
	if (detectedCardtype === 'V') {
	  document.getElementById('payone_cc_visa').style.filter = 'grayscale(0%)';
	  document.getElementById('payone_cc_visa').style.opacity = '1.0';
	  document.getElementById('payone_cc_mastercard').style.filter = 'grayscale(100%)';
	  document.getElementById('payone_cc_mastercard').style.opacity = '0.5';
	} else if (detectedCardtype === 'M') {
	  document.getElementById('payone_cc_visa').style.filter = 'grayscale(100%)';
	  document.getElementById('payone_cc_visa').style.opacity = '0.5';
	  document.getElementById('payone_cc_mastercard').style.filter = 'grayscale(0%)';
	  document.getElementById('payone_cc_mastercard').style.opacity = '1.0';
	} else {
	  document.getElementById('payone_cc_visa').style.filter = 'grayscale(100%)';
	  document.getElementById('payone_cc_visa').style.opacity = '0.5';
	  document.getElementById('payone_cc_mastercard').style.filter = 'grayscale(100%)';
	  document.getElementById('payone_cc_mastercard').style.opacity = '0.5';
	}
      } //,
      // deactivate: true // To turn off automatic card type detection.
    },
    language: payone_cc_language(),
    error: "payone_cc_error" // area to display error-messages (optional)
  };
  window.payone_cc_api = new Payone.ClientApi.HostedIFrames(payone_cc_config, request);
  console.log(window.payone_cc_api)

  // for debugging code
  //
  // document.getElementById("payone_cc_submit").onclick = function () {
  //   payone_cc_api_submit();
  // };

  var pseudocardpan = document.getElementById("payment_payone_cc_pseudocardpan").value
  if (pseudocardpan == '')
    document.getElementById("payone-payment-active-card").style.display = "none";
  else
    document.getElementById("payone-payment-form").style.display = "none";

  if (document.getElementById("payone-change-card-button")) {
    document.getElementById("payone-change-card-button").onclick = function (ev) {
      document.getElementById("payone-payment-active-card").style.display = "none";
      document.getElementById("payone-payment-form").style.display = "block";
      document.getElementById("payment_payone_cc_pseudocardpan").value    = '';
      document.getElementById("payment_payone_cc_truncatedcardpan").value = '';
      document.getElementById("payment_payone_cc_cardtype").value         = '';
      document.getElementById("payment_payone_cc_cardexpire").value       = '';
      ev.preventDefault();
      ev.stopPropagation();
    };
  };
}

// Function called by submitting PAY-button
function payone_cc_api_submit() {
  if (window.payone_cc_api.isComplete()) {
    console.log("payone_cc_api.isComplete true")
    // Perform "CreditCardCheck" to create and get a PseudoCardPan; then call your function "payCallback"
    window.payone_cc_api.creditCardCheck('payone_cc_api_callback');
  } else {
    console.log("payone_cc_api.isComplete false")
    var pseudocardpan = document.getElementById("payment_payone_cc_pseudocardpan").value
    if (pseudocardpan === '') {
      document.getElementById("payone_cc_error").innerHTML = payone_cc_incomplete_text();
    } else {
      console.log("inside payone creditCardCheck");
      document.getElementById("payment_form").requestSubmit();
    }
  }
}

function payone_cc_api_callback(response) {
  console.log("inside payone_cc_api_callback");

  if (response.status === "VALID") {
    document.getElementById("payment_payone_cc_pseudocardpan").value    = response.pseudocardpan;
    document.getElementById("payment_payone_cc_truncatedcardpan").value = response.truncatedcardpan;
    document.getElementById("payment_payone_cc_cardtype").value         = response.cardtype;
    document.getElementById("payment_payone_cc_cardexpire").value       = response.cardexpiredate;

    document.getElementById("payment_form").requestSubmit();
  }

  // debug
  if (typeof response === 'object') {
    var responseAsString = 'time: ' + new Date().getTime() + "\n";
    for (var key in response) {
      if (response.hasOwnProperty(key)) {
	responseAsString += key + ': ' + response[key] + "\n";
      }
    }
    document.getElementById('jsonResponsePre').innerHTML = responseAsString;
  }
}

window.payone_cc_api_submit = payone_cc_api_submit;
window.payone_cc_api_callback = payone_cc_api_callback;
